import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const nivelPrioridadImporterSelectors = importerSelectors(
  'nivelPrioridad.importer',
);

export default nivelPrioridadImporterSelectors;
